import {
  SELECT_STATE,
  SELECT_LOCATION,
  USER_DATA_VALID
} from './constants'

export const stateChanged = (id, name) => {
  return {
    type: SELECT_STATE,
    state: {
      id,
      name
    }
  }
}

export const locationChanged = (id, name) => {
  return {
    type: SELECT_LOCATION,
    location: {
      id,
      name
    }
  }
}

export const userDataValid = (user) => {
  return {
    type: USER_DATA_VALID,
    user
  }
}



// WEBPACK FOOTER //
// ./src/scenes/NewClient/actions.js